"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTemplate = void 0;
const getTemplate = async (supabase, template_id, language_code) => {
    const { data: template, error: template_error } = await supabase
        .from("email_templates")
        .select(`*, versions:email_template_versions(*, language:languages(*))`)
        .eq("id", template_id)
        .eq("versions.language.code", language_code)
        .eq("active", true)
        .single();
    if (template_error) {
        return null;
    }
    if (template.versions.length === 0)
        return null;
    const result = {
        name: template.name,
        description: template.description,
        category: template.category,
        snippet: template.versions[0].snippet,
        sub_category: template.sub_category,
        subject: template.versions[0].subject,
        html: template.versions[0].html,
        default_recipient: template.default_recipient,
        active: template.active,
    };
    return result;
};
exports.getTemplate = getTemplate;
